<template name = "dateTemplate" lang="html">
	 <!-- Create From -->
    <!-- Top bar-->
   <div class="row">
      <b-loading :is-full-page="isFullPage" :active.sync="isLoading" :can-cancel="true"></b-loading>
      
  
    <div id="sidebarMenu" class="sidebar sidebar-fixed bg-white">
			<div class="sidebar-header">
				<h5>Search</h5>
				<a href="" id="sidebarMenuClose"><i data-feather="x"></i></a>
			</div><!-- df-sidebar-header -->
		</div><!-- sidebar -->
      <div class="content content-components">
         <div class="container pd-x-0 pd-lg-x-10 pd-xl-x-0 bs">  
         <div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
            <div>
              <nav aria-label="breadcrumb">
                <ol class="breadcrumb breadcrumb-style1 mg-b-10">
                  <li class="breadcrumb-item">{{this.mainName}}</li>
                  <li class="breadcrumb-item active" aria-current="page">{{this.subName}}</li>
                </ol>
                <h4 class="mg-b-0 tx-spacing--1">{{this.subName}}</h4>
              </nav>
              
            </div>
            <!-- <div class="card-header d-flex align-items-center justify-content-end"> -->
               <div class="d-none d-md-block">
                  <button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5" v-on:click="saveFilter()"><i data-feather="folder" class="wd-10 mg-r-5"></i>Save</button>
                  <button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5" v-on:click="goList()"><i data-feather="file" class="wd-10 mg-r-5"></i>list</button>
                </div>
          </div>
         
          <div class="mg-t-100 bs2">
              <div class="card ht-100p">
               
                  <form action="form-validation.html" data-parsley-validate class="card-body list-group list-group-flush tx-13list-group list-group-flush tx-13">
                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <label for="input1">업체명 <span class="tx-danger">*</span></label>
                        <input type="text" v-model.trim="companyName" class="form-control" ref="companyName" id="companyName" placeholder="업체명">
                      </div>
                      <div class="form-group col-md-6">
                        <label for="input2">업체코드 <span class="tx-danger">*</span></label>
                        <input type="text" v-on:keyup="engOnlyEvent()" ref="companyCode" v-model.trim="companyCode" class="form-control" id="companyCode" placeholder="업체코드" maxlength="3" style="text-transform: uppercase">
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <label for="input3">담당자</label>
                        <input type="text" v-model.trim="manager" class="form-control" id="manager" placeholder="담당자">
                      </div>
                      <div class="form-group col-md-6">
                        <label for="input4">연락처</label>
                        <input type="text" v-on:keyup="numberCheckEvent()" v-model.trim="telNo" class="form-control" id="telNo" placeholder="연락처">
                      </div>
                    </div>                
                    <div class="form-group">
                      <label for="input5">주소</label>
                      <input type="text" v-model.trim="address" class="form-control" id="address" placeholder="주소">
                    </div> 
                    <div class="modeRedering" v-if="this.saveMode=='update'">
                      <div class="form-group">
                        <label class="label-title">Status</label>
                        <div class="input-group">                             
                        <div class="ml-2 custom-control custom-radio mb-1">
                          <input type="radio" v-model.trim="usedCode" name="usedcode" id="usedcode1" value="1" class="custom-control-input">
                          <label class="custom-control-label" for="usedcode1">Used</label>
                        </div>
                        <div class="ml-2 custom-control custom-radio mb-1">
                          <input type="radio" v-model.trim="usedCode" name="usedcode" id="usedcode0" value="0" class="custom-control-input form-check-input">
                          <label class="custom-control-label" for="usedcode0">Unused</label>
                        </div>
                      </div>
                         
                      </div>
                    </div>
                  </form>
              </div><!-- card -->
            </div>        
           </div>
         </div>
      </div>
</template>

<script>
import Handsontable from 'handsontable';
import {HotTable} from '@handsontable/vue';
import 'handsontable-key-value';
import common from '@/views/Common/common.js';

import {bus} from '../../../main';

export default {
    name: 'Detail',
    props: ['properties'],
    components: {
      HotTable
    },
    computed: {
			sheetSettings() {
				let settings = this.$store.getters.sheetSettings;
				return settings;
			},
		},
    data() {
      return {
        mainName: '',
        subName: '',
        menuData: [],
        saveMode: '',

        mid: '', 
        uid: '', 
        msid: '',
        ssid: '',

        companyHeader:[],        
        dateSearchForms:[],
        
        companyName: '',
        companyCode: '',
        telNo: '',
        manager: '',
        address: '',
        usedCode: '',
        flag: false,

        /* Loading */
				isLoading: false,
				isFullPage: true
      }
    },
    beforeDestroy(){
      bus.$off('menu_data');
    },
    created() {
      bus.$on('menu_data', (data)=>{
      this.menuData = data;  
      //   this.mainName = data[2].mains;
      //   this.subName = data[2].subs[0].menuName;
      //   this.mid = data[2].subs[0].id;
      console.log(this.menuData);
      this.classifyHeader();
      });
      this.modeFilter();
      this.uid = this.properties.uid;
      this.mid = this.properties.mid;
    },
    mounted() {
    
    },
    methods : {
        addCompany() {
          if (!this.companyName) {
              this.$buefy.dialog.alert({
                message: 'Please enter company name.',
                size: 'is-medium',
                type: 'is-danger'
              })
              $("#companyName").focus();
              return;
          } else if (!this.companyCode) {
              this.$buefy.dialog.alert({
                message: 'Please enter company code.',
                size: 'is-medium',
                type: 'is-danger'
              })
              $("#companyCode").focus();
              return;
          }
          this.$buefy.dialog.confirm({
              message: 'Would you like to register?',
              size: 'is-medium',
              onConfirm: async () => {
                  const companyName = this.companyName;
                  const companyCode = this.companyCode.toUpperCase();
                  const telNo       = this.telNo;
                  const manager     = this.manager;
                  const address     = this.address;
      
                  this.$http.post(this.$apiHost + '/'+this.$route.name.replace('_detail','')+'/add', { 
                  companyName, companyCode, telNo, manager, address
                  })
                  .then((res) => {
                    if (res.data.deduplication) {
                      alert(res.data.flag + " is duplicated");
                      if (res.data.flag == "Company Name") {
                        this.companyName = "";
                        this.$refs.companyName.focus();
                      } else if (res.data.flag == "Company Code"){
                        this.companyCode = "";
                        this.$refs.companyCode.focus();
                      }
                    } else {
                        this.$buefy.dialog.confirm({
                            message: 'You have created data. Would you like to leave?',
                            size: 'is-medium',
                            onConfirm: async () => {
                                this.$router.push({name:this.$route.name.replace('_detail',''), params:{mid:this.mid, type:'list'}});
                            },
                            onCancel: () => {
                              return false;
                            }
                        });
                    }
                  })
              },
          });
        },
        engOnlyEvent(evt) {
            $("#companyCode").val( $("#companyCode").val().replace(/[0-9]|[^\!-z]/gi,""));
        },
        numberCheckEvent() {
            this.telNo = (this.telNo.replace(/[^0-9]/g, '')).replace(/(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/,'$1-$2-$3');
            return this.telNo;
        },
        goList() {
            if (this.flag) {
              //등록, 수정 완료시 바로 리스트로 가기때문에 
            } else {
                this.$buefy.dialog.confirm({
                    message: "You didn't do anything. Would you like to go to the list??",
                    size: 'is-medium',
                    onConfirm: async () => {
                        this.$router.push({name:this.$route.name.replace('_detail',''), params:{mid:this.mid, type:'list'}});
                    },
                    onCancel: () => {
                        return false; 
                    }
                });
            }
        },
    
        async classifyHeader() {
            let data = common.menuHeader(this.properties.mid, this.menuData, 3);
            this.mainName = data[0];
            this.subName  = data[1];
            this.msid = data[2];
            this.companyHeader = data[3];
            this.dateSearchForms = [];

            for (let i in this.companyHeader) {
              if (this.companyHeader[i].columnType == "DATE") {
                if (!common.isNull(this.uid)) {
                  this.dateSearchForms.push({'name':this.companyHeader[i].columnName, 'value':'','id':this.companyHeader[i].columnCode, 'division':this.companyHeader[i].columnDivision});
                }
              }
            }
          
        },
   
        async modeFilter() { //create, update 구분 
            if (this.properties.uid) {//update
              this.saveMode = 'update';
              
              await this.$axios.get(this.$apiHost + '/'+this.$route.name.replace('_detail','')+'/content', {params:{'id':this.properties.uid}})
              .then(res => {
                this.companyName = res.data.companyName;
                this.companyCode = res.data.companyCode;
                this.telNo       = res.data.telNo;
                this.manager     = res.data.manager;
                this.address     = res.data.address;
                this.usedCode    = res.data.usedCode;
              })
              .catch((error) => {

              });
            } else {//insert
              //this.addCompany();
              this.saveMode = 'insert';
            }
        },
        async updateCompany() {
            if (!this.companyName) {
                this.$buefy.dialog.alert({
                  message: 'Please enter company name.',
                  size: 'is-medium',
                  type: 'is-danger'
                })
                $("#companyName").focus();
                return;
            } else if (!this.companyCode) {
              this.$buefy.dialog.alert({
                  message: 'Please enter company code.',
                  size: 'is-medium',
                  type: 'is-danger'
              })
              $("#companyCode").focus();
              return;
            }
            this.$buefy.dialog.confirm({
                message: 'Would you like to modify?',
                size: 'is-medium',
                onConfirm: async () => {
                    const companyName = this.companyName;
                    const companyCode = this.companyCode;
                    const telNo       = this.telNo;
                    const manager     = this.manager;
                    const address     = this.address;
                    const uid         = this.uid;
                    const usedCode    = this.usedCode;
                  
                    this.$axios.post(this.$apiHost + '/'+this.$route.name.replace('_detail','')+'/update', { 
                    companyName, companyCode, telNo, manager, address, uid, usedCode
                    })
                    .then((res) => {
                      var result = confirm('You have changed data. Would you like to leave?');
                      if(result){
                        this.$router.push({name:this.$route.name.replace('_detail',''), params:{mid:this.mid, type:'list'}});
                      }else{
                        return false;
                      }
                    });
                },
            });
        },
        saveFilter() {
            if (this.saveMode == 'insert') {
                this.addCompany();
              
            } else if (this.saveMode == 'update') {
                this.updateCompany();
            }
        },
    // companyCodeDeduplication() {
    //   if (this.saveMode != 'update') {//update 일시 중복체크 x
    //     const companyCode = this.companyCode.toUpperCase();
    //     this.$axios.post(this.$apiHost + '/'+this.$route.name.replace('_detail','')+'/deduplication', { 
    //       companyCode
    //       })
    //       .then((res) => {
    //         console.log(res.data);
    //         if (res.data != '0') {
    //           alert('Company code is duplicated');
    //           this.companyCode = "";
    //           this.$refs.companyCode.focus();
    //         }
    //       });
    //   } else {
    //     return false;
    //   }
     
    // },
    // companyNameDeduplication() {
    //   if (this.saveMode != 'update') { 
    //     const companyName = this.companyName;
    //     this.$axios.post(this.$apiHost + '/'+this.$route.name.replace('_detail','')+'/deduplication', { 
    //       companyName
    //       })
    //       .then((res) => {
    //         console.log(res.data);
    //         if (res.data != '0') {
    //           alert('Company name is duplicated');
    //           this.companyName = "";
    //           this.$refs.companyName.focus();
    //         }
    //       });
    //   } else {
    //     return false;
    //   }
    // }
  }
}
</script>
<style>
 div.bs {
  margin-left: 0px;
}
div.bs2 {
  margin-top: auto;
} 
</style>
<style src="../../../../node_modules/handsontable/dist/handsontable.full.css"></style>


// WEBPACK FOOTER //
// src/views/Management/Company/DetailForm.vue